import MyWorkProto from "../../my-work-properties/my-work-proto"
import Task from "../task"
import {MY_WORK_ITEM_AR_TASK} from "../../my-work-properties/my-work-types"
import DatetimeUtils from "../../../gd/utils/datetime-utils"

export default class MyWorkTaskActionRequired extends MyWorkProto {

    private task: Task

    constructor(task: Task) {
        super()

        this.task = task

        // jsonData.myWorkProps = {

        //     isNew                   : jsonData.myWorkProps.isNew,


        //     myWorkCanMoveToInbox    : true,
        //     myWorkCanMoveToSomeday  : true,
        //     myWorkCanChangeDate     : true,
        // }
    }

    get myWorkId() {
        return 't-ar-'+this.task.id
    }

    get myWorkType() {return MY_WORK_ITEM_AR_TASK}

    get title() {return this.task.title}

    get isNew() {
        return this.task.properties?.myWork.actionRequired.isNew
    }

    get isPastdue() {
        return this.endDate ? DatetimeUtils.isBeforeToday(this.endDate) : this.startDate ? DatetimeUtils.isBeforeToday(this.startDate) : false
    }

    get fromUserId() {
        return this.task.properties?.myWork.actionRequired.fromUserId
    }

    get canMoveToInbox() { return true }
    get canMoveToSomeday() { return true }
    get canChangeDate() { return true }
    get canChangePriority() { return true }

    get dateCreated() {
        return this.task.properties?.myWork.actionRequired.sinceMoment
    }

    get startDate() {
        return this.task.scheduleDate
    }

    get endDate() {
        return this.task.scheduleDate
    }

    get startMoment() {
        // in future we shoudl use it when allow time in schedule
        return null
    }

    get endMoment() {
        return null
    }

    get priority() {return this.task.priority}

    // toJSON() {
    //     let res = {}
    //
    //     _.mapKeys(this, (value, key)=>{
    //         switch (key) {
    //             case 'myWorkDateCreated':
    //                 res[key] = value ? DatetimeUtils.momentToUTCISODatetime(value) : null
    //                 break
    //
    //             default: res[key] = value
    //         }
    //     })
    //
    //     return res
    // }
}
